/* DROP KIT — scripts de base (compte à rebours, apparition, fenêtres, livraison estimée) */
(() => {
  if (window.__lgDrop) return; window.__lgDrop = true;
  const ready = (fn) => (document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn));

  function initCountdowns(root = document) {
    root.querySelectorAll('.lg-countdown[data-end]:not([data-init])').forEach((el) => {
      el.dataset.init = '1';
      const end = new Date(el.dataset.end).getTime();
      if (isNaN(end)) return;
      const set = (u, v) => { const n = el.querySelector(`[data-u="${u}"]`); if (n) n.textContent = String(v).padStart(2, '0'); };
      let t;
      const tick = () => {
        let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (s === 0) { el.setAttribute('data-ended', ''); clearInterval(t); return; }
        set('d', Math.floor(s / 86400)); s %= 86400;
        set('h', Math.floor(s / 3600)); s %= 3600;
        set('m', Math.floor(s / 60)); set('s', s % 60);
      };
      t = setInterval(tick, 1000); tick();
    });
  }

  function initReveal(root = document) {
    const els = root.querySelectorAll('.lg-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-lg-open]');
    if (opener) {
      const d = document.getElementById(opener.dataset.lgOpen);
      if (d && d.showModal) { e.preventDefault(); d.showModal(); }
      return;
    }
    if (e.target.closest('[data-lg-close]')) { e.target.closest('dialog')?.close(); return; }
    if (e.target.matches && e.target.matches('dialog.lg-modal')) e.target.close();
  });

  function initDelivery(root = document) {
    root.querySelectorAll('[data-lg-delivery]:not([data-init])').forEach((el) => {
      el.dataset.init = '1';
      const add = (n) => { const d = new Date(); let c = 0; while (c < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; };
      const fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { weekday: 'short', day: 'numeric', month: 'short' });
      const a = el.querySelector('[data-min]'); const b = el.querySelector('[data-max]');
      if (a) a.textContent = fmt.format(add(Number(el.dataset.min)));
      if (b) b.textContent = fmt.format(add(Number(el.dataset.max)));
    });
  }

  const initAll = (root) => { initCountdowns(root); initReveal(root); initDelivery(root); };
  ready(() => initAll(document));
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => initAll(e.target));
})();
